import type { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { isSignedOut } from '@/api/client'
import { Splash } from '@/components/Splash'
import { ErrorState } from '@/components/StatusViews'
import { useMe } from '@/hooks/useMe'
import { currentPath } from '@/lib/returnTo'

/** Renders children only for a signed-in person; sends everyone else to log in and back here afterwards. */
export const RequireSession = ({ children }: { children: ReactNode }) => {
  const me = useMe()
  if (me.isPending) return <Splash />
  if (me.isError) {
    if (isSignedOut(me.error)) return <Navigate to={`/login?returnTo=${encodeURIComponent(currentPath())}`} replace />
    return (
      <div className="p-6">
        <ErrorState error={me.error} onRetry={() => void me.refetch()} />
      </div>
    )
  }
  return children
}
